import Link from 'next/link';
import Image from 'next/image';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <Link href="/" className={cn('flex items-center', className)}>
      <Image
        src="/logo.png"
        alt="Mold Free Mom"
        width={225}
        height={54}
        priority
        // 10% smaller than prior h-14 / sm:h-16 / md:h-[104px] (56→50, 64→58, 104→94)
        className="h-[50px] sm:h-[58px] md:h-[94px] w-auto"
      />
    </Link>
  );
};

export default Logo;
